<template>
  <div>
    <div class="question" v-if="!showAnswer">
        <p class="question__h2 h2">Aufgabe {{question.id}} von 5</p>
        <p class="question__text">{{question.question}}</p>
        <div class="answerCompass">
          <img class="answerCompass__background" :src='this.$root.$data.imagePrefix + "compass.png"'>
          <div class="answerCompass__needleWrapper">
            <img class="answerCompass__needle" 
             v-bind:style="{'transform' : 'rotate(' + transformValue + 'deg)'}" 
            :src='this.$root.$data.imagePrefix + "needle.png"'>
            <div class="answerCompass__north" @mouseover="hoverAnswer(1)" @click="selectAnswer(1)"></div>
            <div class="answerCompass__east" @mouseover="hoverAnswer(2)" @click="selectAnswer(2)"></div>
            <div class="answerCompass__south" @mouseover="hoverAnswer(3)" @click="selectAnswer(3)"></div>
            <div class="answerCompass__west" @mouseover="hoverAnswer(4)" @click="selectAnswer(4)"></div>
          </div>
          <div class="answerCompass__textWrapper" :class="{'answerCompass__textWrapper--north': selectedAnswer === 1, 'answerCompass__textWrapper--east': selectedAnswer === 2,  'answerCompass__textWrapper--west': selectedAnswer === 4 }">
            <p class="answerCompass__text" v-for="answer in question.answers" :key="answer.id" :value="answer.answer"  v-show="answer.id === selectedAnswer">
              {{answer.answer}}</p>
            <p class="answerCompass__text" v-if="selectedAnswer === 0">
              Klicken Sie auf eine der Himmelsrichtungen um eine Antwortmöglichkeit zu wählen.</p>
          </div>
        </div>
         <button class="button button--orange button--fixed" :class="{'button--disabled': selectedAnswer === 0}" :disabled="selectedAnswer === 0" @click="showAnswer = true; goToTop()">Kurs bestätigen</button>
    </div>
    <div class="answer" v-if="showAnswer">
       <p class="answer__h2 h2">Aufgabe {{question.id}} von 5</p>
        <p class="answer__h1 h1">Wert: {{question.topic}}</p>
        <img class="answer__img" :src="getImgUrl(question.image)" :alt="question.topic">
        <p class="answer__text">{{question.description}}</p>
       <button class="button button--orange button--fixed" @click="next">Weiter</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Question',
  data: function() {
      return {
          clickedAnswer: false,
          selectedAnswer: 0,
          showAnswer: false,
          hoveredNorth: false,
          transformValue: 180
      }
  },
  props: {
    question: Object
  },
  methods: {
      goToTop: function() {
        window.scrollTo(document.querySelector('#corporate-values').offsetTop, 0);
      },
      hoverAnswer: function(id) {
        if(!this.clickedAnswer) {
           this.animateNeedle(id);
           this.selectedAnswer = id;
        }
      },
      selectAnswer: function(id) {
        this.animateNeedle(id);
        this.clickedAnswer = true;
        this.selectedAnswer = id;
      },

      animateNeedle: function(id) {
        if (this.selectedAnswer === 0 && id === 1) {
          this.transformValue += 180;
        } else if (this.selectedAnswer === 0 && id === 2) {
          this.transformValue += 270;
        } else if (this.selectedAnswer === 0 && id === 3) {
          this.transformValue += 0;
        } else if (this.selectedAnswer === 0 && id === 4) {
          this.transformValue += 90;
        } else if (this.selectedAnswer === 1 && id === 1) {
          this.transformValue += 0;
        } else if (this.selectedAnswer === 1 && id === 2) {
          this.transformValue += 90;
        } else if (this.selectedAnswer === 1 && id === 3) {
          this.transformValue += 180;
        } else if (this.selectedAnswer === 1 && id === 4) {
          this.transformValue += 270;
        } else if (this.selectedAnswer === 2 && id === 1) {
          this.transformValue += 270;
        } else if (this.selectedAnswer === 2 && id === 2) {
          this.transformValue += 0;
        } else if (this.selectedAnswer === 2 && id === 3) {
          this.transformValue += 90;
        } else if (this.selectedAnswer === 2 && id === 4) {
          this.transformValue += 180;
        } else if (this.selectedAnswer === 3 && id === 1) {
          this.transformValue += 180;
        } else if (this.selectedAnswer === 3 && id === 2) {
          this.transformValue += 270;
        } else if (this.selectedAnswer === 3 && id === 3) {
          this.transformValue += 0;
        } else if (this.selectedAnswer === 3 && id === 4) {
          this.transformValue += 90;
        } else if (this.selectedAnswer === 4 && id === 1) {
          this.transformValue += 90;
        } else if (this.selectedAnswer === 4 && id === 2) {
          this.transformValue += 180;
        } else if (this.selectedAnswer === 4 && id === 3) {
          this.transformValue += 270;
        } else if (this.selectedAnswer === 4 && id === 4) {
          this.transformValue += 0;
        }
      },
      next: function() {
        this.$emit('confirmAnswer', this.selectedAnswer);
        this.selectedAnswer = 0;
        this.clickedAnswer = false;
        this.showAnswer = false;
        this.transformValue = 180;
        this.goToTop();
      },
      getImgUrl(pet) {
        return this.$root.$data.imagePrefix + pet + '.gif';
      }
  } 
}
</script>
<style lang="scss">
@keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

/* Firefox < 16 */
@-moz-keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

/* Internet Explorer */
@-ms-keyframes opacity {
   0% { opacity:0; }
    100% { opacity:1; }
}

/* Opera < 12.1 */
@-o-keyframes opacity {
    0% { opacity:0; }
    100% { opacity:1; }
}

.question {
  opacity: 0;
  animation: 1s ease 0s normal forwards 1 opacity;
  @media all and (-ms-high-contrast:none) {
    opacity: 1;
  }
  &__h1 {
    text-align: center;
     @media (min-width: 768px) {
      font-size: 42px;
    }
  }

  &__h2 {
    margin-top: 0;
  }

  &__text {
    margin-top: 15px;
    padding: 0 25px;
    @media (min-width: 768px) {
      padding: 0 150px;
    }
  }
}

.answerCompass {
  position: relative;
  margin: 0 auto;
  
  @media (min-width: 768px) {
    width: 400px;
    height: 400px;
    margin-top: 60px;
  }

  &__text {
    text-align: center;
  }

  &__background {
    width: 300px; 
    height: 300px;
    @media (min-width: 576px) {
      width: 500px; 
      height: 500px;
    }
    @media (min-width: 768px) {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
    }
  }

  &__needleWrapper {
    position: absolute;
    top: 0;
    left: calc(50% - 150px);
    width: 300px; 
    height: 300px;
    
    @media (min-width: 576px) {
      left: calc(50% - 250px);
      width: 500px; 
      height: 500px;
    }
    @media (min-width: 768px) {
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  &__needle {
    position: absolute;
    top: 0;
    left: calc(50% - 150px);
    width: 300px; 
    height: 300px;
    transform: rotate(180deg);
    transition: transform 1s;

   @media (min-width: 576px) {
      left: calc(50% - 250px);
      width: 500px; 
      height: 500px;
    }

    @media (min-width: 768px) {
      left: 0;
      width: 100%;
      height: 100%;
    }

    &--north {
      transform: rotate(360deg);
    }

     &--north2 {
      transform: rotate(0deg);
    }

     &--west {
      transform: rotate(270deg);
    }

     &--east {
      transform: rotate(90deg);
    }
  }

  &__textWrapper {
    @media (min-width: 768px) {
      &--north {
        top: 10%;
      }

      &--west {
        top: 50%;
        left: 0%
      }

      &--east {
        top: 50%;
        left: 100%;
      }
    }
  }

  &__textWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 18px;
    margin: 20px 0;
    border-radius: 6px;
    min-height: 100px;
    background-color: rgba(59, 72, 80, 0.9);
    background-image: linear-gradient(30deg,
      rgba(59, 72, 80, 0.44),
      rgba(59, 68, 75, 0.44),
      rgba(60, 82, 88, 0.44));
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.2);
    color: #fff;
    white-space: pre-wrap;

    @media all and (-ms-high-contrast:none) {
      min-height: auto;
    }

     @media (min-width: 768px) {
      position: absolute;
      left: 50%;
      top: 78%;
      transform: translate(-50%, 0%);
      width: 300px;

       &--north {
        top: -20%;
      }

      &--west {
        top: 53%;
        left: -8%
      }

      &--east {
        top: 16%;
        left: 108%;
      }
    }
    @media (min-width: 1024px) {
      &--west {
        top: 27%;
        left: -37%;
      }

      &--east {
        top: 32%;
        left: 135%;
      }
    }
  }

  &__north {
     position: absolute;
    top: 19%;
    left: 46%;
    width: 50px;
    height: 50px;

    cursor: pointer;
  }
  &__east {
    position: absolute;
    top: 46%;
    left: 71%;
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
  &__south {
     position: absolute;
    top: 73%;
    left: 45%;
     width: 50px;
    height: 50px;
    cursor: pointer;
  }
   &__west {
     position: absolute;
    top: 46%;
    left: 20%;
     width: 50px;
    height: 50px;
    cursor: pointer;
  }
}

.answer {
 opacity: 0;
  animation: 1s ease 0s normal forwards 1 opacity;
  &__h1 {
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: center;
     @media (min-width: 768px) {
      font-size: 42px;
    }
  }
  &__text {
    padding: 0 25px;
    @media (min-width: 768px) {
      padding: 0 150px;
    }
  }
  &__h2 {
    margin-top: 0;
  }


  &__img {
    width: 75%;
    height: auto;

    @media (min-width: 576px) {
      width: 65%;
    }

    @media (min-width: 768px) {
      width: 50%;
    }

    @media (min-width: 1024px) {
      width: 30%;
    } 
  }
}
.fade-enter-active, .fade-leave-active {
   @media (min-width: 768px) {
  transition: opacity .5s;
   }
}
.fade-enter, .fade-leave-to {
   @media (min-width: 768px) {
  opacity: 0;
   }
}
</style>